import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.value)?_c(VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({},'div',attrs,false),on),[_vm._v(_vm._s(_vm.time(_vm.value)))])]}}],null,false,1765192237)},[_vm._v(_vm._s(_vm.dateTime(_vm.value)))]):[_vm._v("—")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }